module.exports = __webpack_public_path__ + "static/hero-907eedc9b90a1578021afd9efe13b904.png";